module.exports = __webpack_public_path__ + "media/click.18b248aa.mp3";